import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { signUpSelector } from '../../../modules/sign-up/redux/selectors';

const useSignUpPage = () => {
  const location = useLocation();
  const { isLoading } = useSelector(signUpSelector);
  const [formState, setFormState] = useState({
    email: '',
    orgName: '',
    orgId: '',
    uid: ''
  });

  useEffect(() => {
    const values = new URLSearchParams(location.search);

    if (values.get('email') && values.get('orgName') && values.get('orgId') && values.get('uid')) {
      setFormState({
        email: decodeURIComponent(values.get('email')),
        uid: values.get('uid'),
        orgName: decodeURIComponent(values.get('orgName')),
        orgId: values.get('orgId')
      });
    }
  }, [location.search]);

  return { isLoading, formState };
};

export default useSignUpPage;
